<div [formGroup]="this.dateControlForm" class="mt-{{FIELD_SPACING}}">
    <div class="row">
        <div class="col">
            <div class="row">
                <div class="col-md-9">
                    <div class="form-label">
                        {{this.label}}
                    </div> 
                </div>
            </div>
            <div class="row">
                <select id="{{controlYearId}}" formControlName="year" class="form-control date-box">
                    <option value="0">Year</option>
                    <option *ngFor="let y of years" [ngValue]="y">{{y}}</option>
                </select>
                
                <select id="{{controlMonthId}}" formControlName="month" class="form-control date-box">
                    <option value="0">Month</option>
                    <option *ngFor="let m of months" [ngValue]="m.id">{{m.name}}</option>
                </select>
            
                <select id="{{controlDateId}}" formControlName="date" class="form-control date-box">
                    <option value="0">Day</option>
                    <option *ngFor="let d of days" [ngValue]="d">{{d}}</option>
                </select>


            </div>
        </div>
    </div>
</div>

